import { createPortal } from 'react-dom'

interface DropdownPortalProps {
    anchorRef: React.RefObject<HTMLDivElement | HTMLButtonElement>
    containerRef: React.RefObject<HTMLDivElement>
    children: React.ReactNode
}

export function DropdownPortal({
    anchorRef,
    containerRef,

    children,
}: DropdownPortalProps) {
    const positionRect = anchorRef.current?.getBoundingClientRect() ?? {
        bottom: 0,
        top: 0,
        left: 0,
    }
    const sizeRect = containerRef.current?.getBoundingClientRect() ?? {
        width: 0,
        height: 0,
    }

    return createPortal(
        <div
            style={{
                position: 'absolute',
                top: (positionRect?.top ?? 0) + window.scrollY,
                left: (positionRect?.left ?? 0) + window.scrollX,
                width: sizeRect?.width ?? 0,
                zIndex: 10,
            }}
        >
            {children}
        </div>,
        document.body
    )
}
